import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';
import { BASE_PATH } from 'config';
// controller
import Loadable from 'ui-component/Loadable';
import HomeRoutes from './HomeRoutes';
import LoginRoutes from './LoginRoutes';
import PersonalRoute from './PersonalRoutes';
import AdminRoute from './AdminRoutes';
import useAuth from 'hooks/useAuth';
import { DASHBOARD_PATH } from 'config';

const TelegramAccount = Loadable(lazy(() => import('views/authentication/telegram')));
const HubSignIn = Loadable(lazy(() => import('views/authentication/hub-sign-in')));

const LandingPage = Loadable(lazy(() => import('views/pages/landing')));

// 404 Page Not Found
const PageNotFound = Loadable(lazy(() => import('views/pages/maintenance/Error')))



// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    // Login State 
    const { isLoggedIn } = useAuth()
    return useRoutes([{ path: '/auth/telegram', element: <TelegramAccount /> }, { path: '/auth/telegram/complete', element: <TelegramAccount /> }, { path: '/hub-sign-in', element: <HubSignIn /> }, { path: '/', element: <LandingPage /> }, { path: '*', element: <PageNotFound path={isLoggedIn ? DASHBOARD_PATH : BASE_PATH} /> }, LoginRoutes, HomeRoutes, PersonalRoute, AdminRoute]);
}

